var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-page-header"},[_c('TextBlock',{attrs:{"layout":_vm.composite}}),(_vm.double)?_c('TextBlock',{attrs:{"layout":_vm.composite2}}):_vm._e(),(_vm.layout.image)?_c('Imageblock',{attrs:{"layout":{
        imageblock: this.$parent.page.image
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }